import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { SeverityData } from './SeverityData';

export const TrendsOverview = () => {
  return (
    <Stack
      sx={{
        backgroundColor: 'white',
        boxShadow: 2,
        borderRadius: '4px',
        flexDirection: { xs: 'column', lg: 'row' },
        flexWrap: { xs: 'wrap', lg: 'nowrap' },
        borderTopRightRadius: { xs: '16px', lg: '34px' },
        '& > *': { flex: '0 0 auto' },
      }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Box sx={{ width: { xs: '100%', lg: '60%' }, px: 2, pt: 2 }}>
        <Stack direction="row" justifyContent="space-between" sx={{ pl: 2, mb: 1.5 }}>
          <Skeleton variant="rectangular" width={120} height={20} sx={{ m: 0, display: 'inline-block' }} />
          <Skeleton variant="rectangular" width={180} height={30} sx={{ m: 0, display: 'inline-block' }} />
        </Stack>
        <Skeleton variant="rectangular" width="100%" height={192} sx={{ m: 0, mb: 1, display: 'inline-block' }} />
      </Box>

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'center', sm: 'start' }}
        justifyContent="space-evenly"
        spacing={1}
        sx={{ flex: '1', '& > *': { flex: '0 0 40%' } }}
      >
        <Box sx={{ p: 2, pb: 3 }}>
          <Typography variant="overline" sx={{ fontWeight: 500, color: 'text.secondary', ml: 1.5 }}>
            <Skeleton variant="rectangular" width={100} height={12} sx={{ m: 0, display: 'inline-block' }} />
          </Typography>
          <Box>
            <Skeleton variant="circular" width={180} height={180} sx={{ m: 0, display: 'inline-block' }} />
          </Box>
        </Box>
        <Box sx={{ minWidth: '200px', pt: 4 }}>
          <SeverityData />
        </Box>
      </Stack>
    </Stack>
  );
};
